import { render, staticRenderFns } from "./CheckBoxBase.vue?vue&type=template&id=0cb81cd4&scoped=true&lang=pug&"
import script from "./CheckBoxBase.vue?vue&type=script&lang=ts&"
export * from "./CheckBoxBase.vue?vue&type=script&lang=ts&"
import style0 from "./CheckBoxBase.vue?vue&type=style&index=0&id=0cb81cd4&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb81cd4",
  null
  
)

export default component.exports